import QueryString from "query-string";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useJumpsellerCore } from "../../../../cores/jumpseller";
import { useMeCore } from "../../../../cores/me";
import { useRouterCore } from "../../../../cores/router";
import { LoadingSpinnerWembii } from "../../LoadingSpinnerWembii";

export default function JumpsellerPopUp() {
  const { search } = useLocation();
  const { bind } = useJumpsellerCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { goToSocial } = useRouterCore();

  useEffect(() => {
    let cancelled = false;

    const completeOAuth = async () => {
      const { code } = QueryString.parse(search);

      if (code && company?.id) {
        await bind(company.id, code as string, () => {
          getMeSocialSettings(company.id);
        });
      }

      if (!cancelled) {
        goToSocial();
      }
    };

    completeOAuth();

    return () => {
      cancelled = true;
    };
  }, [search, company, bind, goToSocial, getMeSocialSettings]);

  return <LoadingSpinnerWembii active />;
}
